import React, { useContext, useEffect, useState } from "react";

import { List, Card, Button, Typography, notification } from "antd";
import { useHistory } from "react-router";
import axios from "axios";
import { NavContext } from "../../../state/NavContext";

const { Meta } = Card;
const { Text, Link } = Typography;

const GameList = (props) => {
  const history = useHistory();
  const { setActiveIndex, setIsSideBarActive } = useContext(NavContext);

  useEffect(() => {
    setActiveIndex("games");
    setIsSideBarActive(false);
  }, [setActiveIndex, setIsSideBarActive]);

  const defaultData = [
    {
      id: null,
      title: null,
      description: null,
      year: null,
      duration: null,
      rating: null,
      image_url: "home",
    },
    {
      id: null,
      title: null,
      description: null,
      year: null,
      duration: null,
      rating: null,
      image_url: "home",
    },
    {
      id: null,
      title: null,
      description: null,
      year: null,
      duration: null,
      rating: null,
      image_url: "home",
    },
    {
      id: null,
      title: null,
      description: null,
      year: null,
      duration: null,
      rating: null,
      image_url: "home",
    },
  ];

  const [games, setGames] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isCanceled, setIsCanceled] = useState(false);

  useEffect(() => {
    if (!isLoaded) {
      axios
        .get("https://backendexample.sanbersy.com/api/data-game")
        .then((res) => {
          if (!isCanceled) {
            setGames(res.data);
            setIsLoaded(true);
          }
        })
        .catch((err) => {
          if (!isCanceled) {
            notification.error({
              message: "Error Loading Data",
              description: err.response.data.message,
              placement: "topRight",
            });
            console.log(err.response.data.message);
            setIsLoaded(true);
          }
        });
    }

    // cleanup component unmount
    return function () {
      setIsCanceled(true);
    };
  }, []);

  const navigateTo = (path) => {
    setActiveIndex("games");
    history.push(path);
  };

  return (
    <>
      <div className="top-list">
        <h2>{props.maxItem !== null ? "Latest Games" : "All Games"}</h2>
        {props.maxItem !== null ? (
          <Button onClick={() => navigateTo("/games")} type="link">
            View More
          </Button>
        ) : (
          <></>
        )}
      </div>
      <List
        grid={{ gutter: 16, column: 4, sm: 1, md: 2, xs: 1 }}
        dataSource={isLoaded ? games : defaultData}
        renderItem={(item, index) => {
          if (index >= props.maxItem && props.maxItem !== null) {
            return;
          }

          return (
            <List.Item>
              <Card
                className="card-item-list"
                loading={!isLoaded}
                cover={
                  <img
                    onClick={() => navigateTo(`/games/detail/${item.id}`)}
                    src={
                      isLoaded === true
                        ? item.image_url
                        : "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAA1BMVEXR0dFCxnTBAAAASElEQVR4nO3BgQAAAADDoPlTX+AIVQEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADwDcaiAAFXD1ujAAAAAElFTkSuQmCC"
                    }
                    alt={item.name}
                    className="card-image"
                  />
                }
              >
                <Meta
                  title={
                    <Link
                      onClick={() => navigateTo(`/games/detail/${item.id}`)}
                    >
                      {item.name}
                    </Link>
                  }
                />
                <div style={{ marginTop: "16px" }}>
                  <Text>Genre: </Text>
                  <Text type="secondary">{item.genre}</Text>
                </div>
                <div>
                  <Text>Release: </Text>
                  <Text type="secondary">{item.release}</Text>
                </div>
                <Button
                  block
                  className="card-button-detail"
                  onClick={() => navigateTo(`/games/detail/${item.id}`)}
                >
                  View Details
                </Button>
              </Card>
            </List.Item>
          );
        }}
      />
    </>
  );
};

export default GameList;
